//M10-11344 Po related design changes
import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import ViewPo from "./ViewPo";
import { useDispatch } from "react-redux";
import { usePoHandlers } from "./PoController";
import PoGenerate from "./PoGenerate";
import { getAllCompanyDetails } from "src/services/company-api";
import { poActions } from "src/context/po-slice";
import InvoiceLayout from "src/pages/invoice-master/invoice-layout.component";

const PoHomeScreen = () => {
    const dispatch = useDispatch();
    const { tabIndex } = useParams();

    let tabs = [
        {
            title: "View PO details",
            component: < ViewPo />,
        },
        {
            title: "PO Generate",
            component: <PoGenerate />,
        },
    ];

    const {
        fetchState,
    } = usePoHandlers();

    useEffect(() => {
        getAllCompanyDetails()
            .then((res) => dispatch(poActions.setPoFiltersData({ key: "company", value: res.data })))
            .catch((err) => console.log(err));
        fetchState
    }, [])

    return (
        <InvoiceLayout>
            <header className="flex flex-col justify-between py-5 mx-auto max-h-[100vh]">
                <div className="flex justify-between px-[3.75rem]">
                    <div className="">
                        <h1 className="text-[#49484C] font-bold text-[2rem]">PO Details</h1>
                    </div>
                </div>

                <Tab.Group defaultIndex={Number(tabIndex) ?? 0}>
                    <Tab.List className="relative px-[3.75rem] mb-[1.16rem] mt-2 border-b-[1px] border-b-[#E9E9E9] shadow-md">
                        {tabs.map((item: any) => (
                            <Tab key={item.title} as={Fragment}>
                                {({ selected }: { selected: boolean }) => (
                                    <div
                                        className={`relative inline-block cursor-pointer -bottom-[1px] px-4 py-3 font-semibold text-sm  border-b-2  not-italic  hover:border-b-[#586AF5] hover:text-[#586af5] focus:outline-none ${selected ? "text-[#586af5] border-b-[#586AF5]" : "text-[rgba(0,0,0,0.4)] border-b-transparent"
                                            }`}
                                    >
                                        {item.title}
                                    </div>
                                )}
                            </Tab>
                        ))}
                    </Tab.List>
                    <Tab.Panels>
                        {tabs.map((item: any) => (
                            <Tab.Panel className="px-[3.75rem]" key={item.title}>
                                {item.component}
                            </Tab.Panel>
                        ))}
                    </Tab.Panels>
                </Tab.Group>
            </header>
        </InvoiceLayout>
    );
};

export default PoHomeScreen;
//M10-11344 Po related design changes